'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * True if the node has no text and no void descendants
 */
function isEmpty(opts, editor, node) {
    if (node.object === 'text') {
        return node.text == '';
    } else {
        return !editor.isVoid(node) && !node.nodes.some(function (child) {
            return !isEmpty(opts, editor, child);
        });
    }
}

exports.default = isEmpty;